import { faTableCellsLarge } from '@awesome.me/kit-b4fd369ea4/icons/classic/solid'
import { Title } from '../title/Title'

export const Home = () => {
  return (
    <Title title="Home" icon={faTableCellsLarge}/>
  )
}